<template>
  <div class="main-banner header-text" id="top">
    <div
      id="modernSliderCarousel"
      class="carousel slide Modern-Slider"
      data-bs-ride="carousel"
    >
      <!-- Carousel Indicators -->
      <div class="carousel-indicators">
        <button
          type="button"
          data-bs-target="#modernSliderCarousel"
          data-bs-slide-to="0"
          class="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button
          type="button"
          data-bs-target="#modernSliderCarousel"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>
        <!-- <button type="button" data-bs-target="#modernSliderCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button> -->
      </div>

      <!-- Carousel Inner -->
      <div class="carousel-inner">
        <!-- First Item -->
        <div class="carousel-item active item item-1">
          <div class="img-fill">
            <div class="text-content">
              <h6>We are ready to help you</h6>
              <h4>
                ICT &amp; Media Tech <br />
                Business Consulting
              </h4>
              <p>
                We are pioneers in ICT & Media Tech Business Consulting,
                offering cutting-edge solutions for the digital age. Our
                expertise helps companies navigate the complex landscape of
                information, communication, and media technologies, driving
                innovation and growth in today's fast-paced tech ecosystem.
              </p>
              <router-link to="/contact" class="filled-button"
                >Contact Us</router-link
              >
            </div>
          </div>
        </div>

        <!-- Second Item -->
        <div class="carousel-item item item-2">
          <div class="img-fill">
            <div class="text-content">
              <h6>We have a solid background</h6>
              <h4>Telecom<br />Solutions</h4>
              <p>
                Revolutionizing connectivity, we deliver comprehensive telecom
                solutions tailored to meet the evolving needs of businesses and
                consumers alike. Our cutting-edge services encompass network
                infrastructure, cloud communications, and advanced mobile
                technologies, empowering organizations to stay ahead in an
                increasingly connected world.
              </p>
              <router-link to="/services" class="filled-button"
                >Our Services</router-link
              >
            </div>
          </div>
        </div>

        <!-- Third Item -->
        <!-- <div class="carousel-item item item-3">
          <div class="img-fill">
            <div class="text-content">
              <h6>We have a solid background</h6>
              <h4>Market Analysis<br>&amp; Statistics</h4>
              <p>You can download, edit and use this layout for your business website. Phasellus lacinia ac sapien vitae
                dapibus. Mauris ut dapibus velit cras interdum nisl ac urna tempor mollis.</p>
              <router-link to="/about" class="filled-button">Learn More</router-link>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Carousel Controls -->
      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#modernSliderCarousel"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#modernSliderCarousel"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</template>
